import { useMemo } from 'react';

import useAuthorizedCreateModalTypes from '@/hooks/useAuthorizedCreateModalTypes';

import { getAuthorizedOptions } from '../CreateButton.helpers';
import { CreateMenuItem } from '../CreateButton.types';

const useAuthorizedCreateOptions = ({
  onCreateModalOpen,
}: {
  onCreateModalOpen: (menuItem: CreateMenuItem) => void;
}): CreateMenuItem[] => {
  const authorizations = useAuthorizedCreateModalTypes();

  return useMemo(() => {
    return getAuthorizedOptions(authorizations, onCreateModalOpen);
  }, [authorizations, onCreateModalOpen]);
};

export default useAuthorizedCreateOptions;
